angular.module('unergie.main')
.controller('variablesCtrl', ($scope, $state, $uibModal, AlertManager, DataAccessRefVariables,
    NgTableParams, ErrorCatcher) => {
    $scope.isActive = (state) => $state.is(state)

    const refresh = function () {
        $scope.refreshing = true
        return DataAccessRefVariables.getVariables().$promise.then((result) => {
            const data = _.orderBy(result, 'from_date', 'desc')
            data.forEach((elem) => (elem.from_date = moment(elem.from_date).toDate()))
            $scope.tableParams = new NgTableParams({
                page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 10,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [10, 25, 50, 100], dataset: data }) }).catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.refresh = refresh
    refresh()

    $scope.delete = (variable) =>
        DataAccessRefVariables.delVariable({ id: variable.id }).$promise.then((data) => refresh()).catch(ErrorCatcher)


    const variableTemplate = {
        key: '',
        value: '',
        from_date: new Date(),
    }
    $scope.variableFields = {
        key: {
            label: 'Variable',
            required: true,
            type: 'text',
        },
        value: {
            label: 'Valeur',
            required: true,
            type: 'text',
        },
        from_date: {
            label: 'Date d\'effet',
            type: 'date',
        },
    }

    $scope.updateVariableFields = angular.copy($scope.variableFields)
    $scope.updateVariableFields.key.hidden = true

    const resetVariablePayload = () => ($scope.variablePayload = angular.copy(variableTemplate))

    resetVariablePayload()

    $scope.addVariable = () =>
        DataAccessRefVariables.addVariable($scope.variablePayload).$promise.then(() => {
            resetVariablePayload()
            return refresh() }).catch(ErrorCatcher)


    $scope.updateVariable = function (variable) {
        const variablePayload = angular.copy(variable)
        delete variablePayload.id
        return DataAccessRefVariables.updateVariable({ id: variable.id }, variablePayload).$promise.then(() => {
            AlertManager.success('Variable modifiée')
            return refresh() }).catch(ErrorCatcher)
    }

    $scope.deleteVariable = (variable) =>
        DataAccessRefVariables.delVariable({ id: variable.id }).$promise.then(() => {
            AlertManager.success('Variable supprimée')
            return refresh() }).catch(ErrorCatcher)
})
